/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Pr_TitleInputs */

const en_fc_vs_who_pr_title = /** @type {(inputs: Fc_Vs_Who_Pr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay with Premiere Pro if you…`)
};

/**
* | output |
* | --- |
* | "Stay with Premiere Pro if you…" |
*
* @param {Fc_Vs_Who_Pr_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_pr_title = /** @type {((inputs?: Fc_Vs_Who_Pr_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Pr_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_pr_title(inputs)
});
export { fc_vs_who_pr_title as "fc.vs.who.pr.title" }